module.exports = __webpack_public_path__ + "img/cloud_computing.7644623b.png";